// TODO: https://lessonup.atlassian.net/browse/UP-111 - Create a system with design
export const transition = {
  duration: {
    slow: {
      string: '450ms',
      number: 0.45,
    },
    medium: {
      string: '300ms',
      number: 0.3,
    },
    fast: {
      string: '150ms',
      number: 0.15,
    },
  },
};
